module.exports = __webpack_public_path__ + "media/images/global/icons/movie-b6d88f8fd828e3c113729de2703b2a41.svg";